import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'submit']

  connect () {
    this.toggleSubmit()
    this.inputTargets.forEach(input => {
      input.addEventListener('input', this.toggleSubmit.bind(this))
    })
  }

  toggleSubmit () {
    const hasEmptyInput = this.inputTargets.some(input => input.value.trim() === '')
    this.submitTarget.disabled = hasEmptyInput
  }
}
